import { Button } from "react-bootstrap";

export const NextPrevButtons = ({
  step,
  onPrevious,
  onNext,
  getDisableForPage,
}: {
  step: number;
  onPrevious: any;
  onNext: any;
  getDisableForPage: any;
}) => {
  return (
    <div
      className={"d-flex justify-content-" + (step !== 0 ? "between" : "end")}
    >
      {step !== 0 && <Button onClick={onPrevious}>Anterior</Button>}
      {step !== 2 && (
        <Button onClick={onNext} disabled={getDisableForPage()}>
          Siguiente
        </Button>
      )}
    </div>
  );
};
